import React, { Component, PureComponent } from 'react';
import { connect } from "react-redux";
import Modal from 'react-modal';
import moment from 'moment';
import globals from '../../../common/globals';
import ProgressSpinnerSmall from '../../../common/ProgressSpinnerSmall';
import TagsTreeView from '../../../TagsTreeView';
import TagTypesDropDown from '../../../TagTypesDropDown';
import TagsTreeViewDropDown from '../../../TagsTreeViewDropDown';
import TagsList from '../../../TagsList';
import Analytics from 'APP_ROOT/services/analytics';
import ReactTable from 'react-table';
import ProgressOverlay from '../../../common/ProgressOverlay';
import DataWidget from '../DataWidget/DataWidget';
import EditPlanModal from '../editPlanModal';
import TagPermissions from '../../../common/tagsPermissions';
import { DispatchHelpers, Selectors, TAG_TYPES } from '../../../../data/tags';
import { strings } from '../../../../localization';
import BuildSettings from '../../../buildSettings';
import TagsUtil, {TAG_ACTIONS} from '../../../common/tagsUtils';


const Tabs = {
    TAGS: 'tags',
    DATA_USAGE: 'data_usage',
    PLAN: 'plan',
}

class RavensPage extends Component {

    state = {
        dataSet: false,

        isRavenModalOpen: false,
        editPlanModalOpen: false,

        currentRaven: null,
        ravens: undefined,
        filteredRavens: undefined,

        filters: [], // for ravens list

        filterRavenTagsByKeyword: '', // For raven tags list
        filterRavenTagsByType: [], // For raven tags list

        successMessage: null,
        errorMessage: null,

        modalCurrentTab: Tabs.TAGS,

        showServicePlan: this.props.features.show_service_plan
    }

    componentDidMount() {
        Analytics.pageView();

        if(this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }
    }

    componentDidUpdate() {
        if(!this.state.dataSet && this.props.tags && this.props.ravens && this.props.users){
            this.setData();
        }
    }

    setData = () => {

        if(!this.props.tagsInheritedUsersAreSet){
            return;
        }

        TagPermissions.setData(this.props.user, {tags: this.props.tags, users: this.props.users, ravens: this.props.ravens});

        let userIsOwner = true;
        
        if(this.props.accountDetails){
            userIsOwner = this.props.user.email === this.props.accountDetails.email;
        }

        let hasRavensWithoutTags = false;

        const tags = TagPermissions.getUserTags(this.props.user, this.props.accountDetails, this.props.tags);
        const ravens = TagPermissions.getUserRavens(this.props.user, this.props.accountDetails, this.props.ravens, tags);

        ravens.forEach(raven => {
            if(raven.tags.length === 0){
                hasRavensWithoutTags = true;
            }
        });

        if(hasRavensWithoutTags && userIsOwner){
            // filterByTagsOptions.unshift({label: 'Without tag', value: -1, checked: false});
        }

        this.setState({
            ravens,
            filteredRavens: this.filterRavens(ravens, this.state.filters),
            tags,
            dataSet: true,
        });

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('edit')) {
            const ravenUuid = urlParams.get('edit');
            const currentRaven = ravens.find(raven => raven.ravenUuid === ravenUuid);

            if (currentRaven) {
                this.setState({ currentRaven });
                this.openRavenPlanModal(currentRaven);
                this.openEditPlanModal();
            }
            
            urlParams.delete('edit');
            window.history.replaceState({}, '', `${window.location.pathname}`);
        }
    }

    openEditPlanModal = (e) => {

        if (e) e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            editPlanModalOpen: true
        });
    }

    closeEditPlanModal = (e) => {

        if (e) e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            editPlanModalOpen: false
        });
    }

    openRavenDataUsageModal = (raven) => {
        this.openRavenModal(raven, Tabs.DATA_USAGE);
    }

    openRavenPlanModal = (raven) => {
        this.openRavenModal(raven, Tabs.PLAN);
    }

    openRavenTagsModal = (raven) => {
        this.openRavenModal(raven, Tabs.TAGS);
    }

    openRavenModal = (raven, tab) => {
        this.setState({ 
            isRavenModalOpen: true, 
            currentRaven: raven,
            errorMessage: null, 
            successMessage: null,
            modalCurrentTab: tab,
        });
    }

    closeRavenModal = () => {
        this.setState({ 
            isRavenModalOpen: false, 
            currentRaven: null, 
            errorMessage: null, 
            successMessage: null,
            filterRavenTagsByKeyword: '',        
        });

        this.setData();
    }
    
    changeModalCurrentTab = (tab) => {
        this.setState({ modalCurrentTab: tab });
    }

    onRavenTagUnassign = (tag) => {
        const currentRaven = this.state.currentRaven;

        this.setState({ errorMessage: null, successMessage: null });

        this.props.deleteTagRaven(tag.tagId, currentRaven)
            .then((affectedTags) => { // raven is removed from the tag and that tag's descendant tags (if any)

                // remove tags from raven.tags list
                TagPermissions.removeTagsFromRaven(currentRaven, affectedTags);
                
                this.setState({ 
                    currentRaven,
                    successMessage: strings.formatString(strings.tags_unassign_success, currentRaven.vehicle.name, tag.name)
                });
            })
            .catch(error => {
                console.error(error);
                this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.UNASSIGN_RAVEN, tag.name, currentRaven.vehicle.name) });
            });
            
    }

    onRavenTagsChange = (selectedTagIds) => {
        const currentRaven = this.state.currentRaven;
        const currentTags = currentRaven.tags;

        this.setState({ errorMessage: null, successMessage: null});

        // In each call there is only one change in selectedTags (new tag to be added or existing tag to be removed)

        // Check if there is a new tag to be added
        const newTagId = selectedTagIds.find(tagId => !currentTags.some(ct => ct.tagId === tagId));

        if(newTagId){

            const newTag = this.state.tags.find(t => t.tagId === newTagId);

            this.props.addTagRaven(newTagId, this.state.currentRaven)
            .then((affectedTags) => { // raven is added to the new tag and that tag's parent tags (if any)
                
                // update raven.tags list
                TagPermissions.addTagsToRaven(currentRaven, affectedTags);

                this.setState({ 
                    currentRaven,
                    successMessage: strings.formatString(strings.tags_assign_success, currentRaven.vehicle.name, newTag.name)
                });
            })
            .catch(error => {
                console.error(error);
                
                this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.ASSIGN_RAVEN, newTag.name, currentRaven.vehicle.name) });
            });

            return;
        }

        // Check if there is a tag removed
        const deletedTag = currentTags.find(ct => !selectedTagIds.includes(ct.tagId));

        if(deletedTag){
            this.props.deleteTagRaven(deletedTag.tagId, this.state.currentRaven)
            .then((affectedTags) => { // raven is removed from the tag and that tag's descendant tags (if any)

                TagPermissions.removeTagsFromRaven(currentRaven, affectedTags);

                this.setState({ 
                    currentRaven,
                    successMessage: strings.formatString(strings.tags_unassign_success, currentRaven.vehicle.name, deletedTag.name)
                 });
            })
            .catch(error => {
                console.error(error);
                this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.UNASSIGN_RAVEN, deletedTag.name, currentRaven.vehicle.name) });
            });
        }   
    }

    setListFilters = (filterId, value) => {
        let filters = [...this.state.filters];
        const indexOfFilter = filters.findIndex(filter => filter.id === filterId);
        
        if(filterId === 'vehicle.name'){
            if(indexOfFilter > -1){
                if(value)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        if(filterId === 'tags'){
            if(indexOfFilter > -1){
                if(value.length > 0)
                    filters[indexOfFilter] = {id: filterId, value};
                else
                    filters = filters.filter(filter => filter.id !== filterId);
            }else{
                if(value.length > 0)
                    filters = [...filters, {id: filterId, value}];
            }
        }

        const filteredRavens = this.filterRavens(this.state.ravens, filters);

        this.setState({ filters, filteredRavens });
    }

    filterRavens = (ravens, filters) => {
        let list = ravens || [];

        const nameFilter = filters.find(filter => filter.id === 'vehicle.name');
        
        if(nameFilter){
            list = list.filter(raven => raven.vehicle.name.toLowerCase().includes(nameFilter.value.toLowerCase()));
        }
        
        const tagsFilters = filters.find(filter => filter.id === 'tags');

        if(tagsFilters){
            const selectedTagsIds = tagsFilters.value;
            const noTagFilter = false; //this.state.filterByTagsOptions.find(option => option.checked && option.value === -1);

            if(selectedTagsIds.length > 0 || noTagFilter){

                list = list.filter(raven => {
                    return raven.tags.some(tag => selectedTagsIds.includes(tag.tagId)) || // If any of the selected tags is in the user tags
                        (noTagFilter && raven.tags.length === 0); // If the user has no tags and the no tag filter is selected
                });
            }
        }

        return list;
    }

    filterRavenTags = () => {
        let list = this.state.currentRaven.tags;

        // list = list.concat(this.state.currentRaven.selectedTags);

        if(this.state.filterRavenTagsByKeyword){
            list = list.filter(tag => tag.name.toLowerCase().includes(this.state.filterRavenTagsByKeyword.toLowerCase()));
        }

        if(this.state.filterRavenTagsByType.length > 0){
            list = list.filter(tag => this.state.filterRavenTagsByType.includes(tag.type));
        }

        return list;
    }
    
    shouldRenderRavenDataUsage = (subscription) => {
        
        if(!this.state.showServicePlan) return false;

        if(!subscription) return false;

        if(subscription.planCode === "nsp") return false;

        return true;
    }

    shouldRenderRavenSubscription = (subscription) => {
        
        if(!this.state.showServicePlan) return false;

        return true;
    }

    getRavenDataUsageDetails(subscription) {
        
        if(subscription.planCode === "nsp") {
            return null;
        }

        const planTotalSizeBytes = subscription.planData;
        if (!planTotalSizeBytes && planTotalSizeBytes !== 0) {
            console.error("Account Raven subscription invalid planData property");
            return null;
        }
        const dataUsageDetails = subscription.dataUsage? subscription.dataUsage : null;
        if (dataUsageDetails === null) { // 0 is a valid usage! check for 'null'
            console.error("Account Raven subscription invalid dataUsage property");
            return null;
        }

        const dataUsageGrandTotalBytes = dataUsageDetails.used;
        if (dataUsageGrandTotalBytes === null) { // 0 is a valid usage! check for 'null'
            console.error("Account Raven subscription dataUsage invalid used property");
            return null;
        }

        const dataUsageGrandTotalAvailable = dataUsageDetails.available;
        if (!dataUsageGrandTotalAvailable && dataUsageGrandTotalAvailable !== 0) {
            console.error("Account Raven subscription dataUsage invalid available property");
            return null;
        }

        const topUps = dataUsageDetails.topups? dataUsageDetails.topups : [];
        if (!dataUsageDetails.topups) {
            console.error("Account Raven subscription dataUsage invalid topups property"); // tops up should at least be an empty array
            // no return (we still have enough to at least show what the customer has used while we fix the problem)
        }
        

        const usedMBNoDecimalPlace = Math.round(dataUsageGrandTotalBytes/1000000);

        const availableGBOneDecimalPlace = Math.round((dataUsageGrandTotalAvailable/1000000000) * 10) / 10;

        const usedGBOneDecimalPlace = Math.round((dataUsageGrandTotalBytes/1000000000) * 10) / 10;
        
        const usedPercentage = Math.round((usedGBOneDecimalPlace / availableGBOneDecimalPlace) * 100);

        return {
            planTotalSizeBytes,
            usedMBNoDecimalPlace,
            usedGBOneDecimalPlace,
            usedPercentage,
            availableGBOneDecimalPlace,
            dataUsageGrandTotalBytes,
            dataUsageGrandTotalAvailable,
            dataUsageDetails,
            topUps
        }
    }

    isContentReady = () => {
        const { tagsError, tagsLoading, usersError } = this.props;
        
        if(tagsError || tagsLoading || usersError || !this.state.dataSet) return false;

        return true;
    }

    renderContentLoadingStatus = () => {
        let issue = null;

        // There is no error, no pending and no loaded tags. So, can conclude Tags are not enabled.
        const tagsNotEnabled = !this.props.tagsLoaded && !this.props.tagsLoading && !this.props.tagsError;

        if(tagsNotEnabled){
            issue = <div className='error-message'>{strings.tags_not_enabled}</div>;
        }
        else if(this.props.tagsError || this.props.usersError){
            issue = <div className='error-message'><i className="material-icons">error_outline</i>{strings.loading_data_error}</div>;
        }
        else if(this.props.tagsLoading || !this.state.dataSet){
            issue = <div className='loading-data'><ProgressSpinnerSmall/><div>{strings.loading_data}</div></div>
        }

        return issue;
    }

    renderRavenModal = () => {
        const ravenTagsFiltered = this.filterRavenTags();

        const ravenTagsIds = this.state.currentRaven.tags.map(tag => tag.tagId);

        const includeSystemType = this.state.currentRaven.tags.some(tag => tag.type === TAG_TYPES.SYSTEM);

        return (
            <>
            <Modal 
                isOpen={this.state.isRavenModalOpen}
                className="tags-action-modal react-modal-content react-modal"
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={false}
                onRequestClose={this.closeRavenModal}
            >
                <div className="container-fluid">
                    <div className='row header'>
                        <div className='col-12'>
                            <h2>{strings.raven_name} <span className='assigned-to'>{this.state.currentRaven.vehicle.name}</span></h2>
                        </div>
                        <div className='col-12'>
                            {this.state.successMessage && <div className='success-message'>{this.state.successMessage}</div>}
                            <ul className='errors'>
                                {this.state.errorMessage &&  <li className='error-message'>{this.state.errorMessage}</li>}
                            </ul>
                        </div>
                    </div>

                    {/* Tabs */}
                    {this.renderRavenModalTabs()}

                    {/* Data Usage */}
                    {(this.shouldRenderRavenDataUsage(this.state.currentRaven.subscription) && this.state.modalCurrentTab === Tabs.DATA_USAGE) &&
                        <>{this.renderDataUsageTab(this.state.currentRaven.subscription)}</>
                    }

                    {/* Plan */}
                    {(this.state.modalCurrentTab === Tabs.PLAN) &&
                        <>
                            {this.renderSubscriptionTab(this.state.currentRaven.subscription)}
                        </>
                    }
                    
                    {/* Tags */}
                    {this.state.modalCurrentTab === Tabs.TAGS && 
                        <div className='row modal-main-content'>
                            {/* All the available tags  */}
                            <div className='col-6 col-xl-5'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <h3>{strings.tags_available_tags}</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    {/* Tags Treeview*/ }
                                    <div className='col-12'>
                                        <TagsTreeView 
                                            tags={this.state.tags}
                                            resource={this.state.currentRaven.vehicle.name}
                                            expandedTagsIds={ravenTagsIds}
                                            selectedTagsIds={ravenTagsIds}
                                            onChange={this.onRavenTagsChange}
                                            multipleSelection
                                            showConfrimOnDeselect
                                            disableGuestTags
                                            disableRootTag
                                            showTooltips
                                            compact
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Tags assigned to current raven */}
                            <div className='col-6 col-xl-6 offset-xl-1'>
                                <div className="row header">
                                    <div className='col-12'>
                                        <h3>{strings.tags_assigned_tags}</h3>
                                    </div>
                                </div>
                                {/* Filter */}
                                <div className='row'>
                                    <div className="col-12 filters">
                                        <input type="text" placeholder={strings.placeholder_filter} value={this.state.filterRavenTagsByKeyword} onChange={(e) => this.setState({filterRavenTagsByKeyword: e.target.value})} />
                                        <TagTypesDropDown 
                                            includeSystemType={includeSystemType}
                                            selectedItems={this.state.filterRavenTagsByType}
                                            onChange={(selectedItems) => this.setState({filterRavenTagsByType: selectedItems})}
                                            multipleSelection={true}
                                        />
                                    </div>
                                </div>
                                {/* list of raven tags */}
                                <div className='row'>
                                    <TagsList
                                        tags={ravenTagsFiltered}
                                        className={'col-12'}
                                        resource={this.state.currentRaven.vehicle.name}
                                        onUnassign={this.onRavenTagUnassign}
                                        disableRootTag
                                        disableGuestTags
                                        canUnassign
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    
                    {this.state.modalCurrentTab !== Tabs.PLAN && 
                        <div className='row'>
                            <div className="col-12 actions">
                                <button className="btn btn-outline-blue" onClick={this.closeRavenModal}><i className="material-icons">clear</i>{strings.app_close}</button>
                            </div>
                        </div>
                    }
                </div>
                {this.props.tagRavensChangesPending && <ProgressOverlay />}
            </Modal>
            </>
        );
    }

    renderRavenModalTabs = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <ul className="nav nav-tabs" id="raven-modal-tabs" role="tablist">
                        <li className="nav-item">
                            <a className={`nav-link ${ this.state.modalCurrentTab === Tabs.TAGS ? 'active' : ''}`} id="tags-tab" data-toggle="tab" onClick={() => this.changeModalCurrentTab(Tabs.TAGS)} role="tab">{strings.tags_label}</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${ this.state.modalCurrentTab === Tabs.PLAN ? 'active' : ''}`} id="plan-tab" data-toggle="tab" onClick={() => this.changeModalCurrentTab(Tabs.PLAN)}  role="tab">{strings.plan_title}</a>
                        </li>
                        {this.shouldRenderRavenDataUsage(this.state.currentRaven.subscription) && 
                        <li className="nav-item">
                            <a className={`nav-link ${ this.state.modalCurrentTab === Tabs.DATA_USAGE ? 'active' : ''}`} id="data-usage-tab" data-toggle="tab" onClick={() => this.changeModalCurrentTab(Tabs.DATA_USAGE)}  role="tab">{strings.data_usage_title}</a>
                        </li>
                        }                    
                    </ul>
                </div>
            </div>
        );
    }

    renderStats = () => {
        
        const list = this.state.ravens;

        if(!list) return null;

        const stats = {
            total: list.length,
            withoutTag: list.filter(raven => raven.tags.length === 0).length,
            noSDCard: list.filter(raven => raven.sdCardStatus.toLowerCase() !== 'inserted').length,
            unplugged: list.filter(raven => raven.unplugged).length,
        }

        const totalLabel = strings.stats_total_label;

        return (
            <div className='col-12 stats'>
                <div><label>{totalLabel}: </label><span>{stats.total}</span></div>
                <div><label>{strings.stats_without_tags_label}: </label><span>{stats.withoutTag}</span></div>
                {/* <div><label>No SDCard: </label><span>{stats.noSDCard}</span></div>
                <div><label>Unplugged: </label><span>{stats.unplugged}</span></div> */}
            </div>
        );
    }
    
    renderDataUsageTab(subscription) {
        
        const details = this.getRavenDataUsageDetails(subscription);

        if(!details) return null;

        const { usedMBNoDecimalPlace, 
            topUps, 
            planTotalSizeBytes, 
            dataUsageGrandTotalBytes, 
            dataUsageGrandTotalAvailable, 
            usedGBOneDecimalPlace, 
            availableGBOneDecimalPlace, 
            dataUsageDetails } = details;

        var dateUsageSummary = strings.formatString(strings.data_usage_0_mb_of_1_gb_used_so_far, usedMBNoDecimalPlace, availableGBOneDecimalPlace);
        if (usedMBNoDecimalPlace >= 1000) { // checking value when rounded to the nearest MB (twilio-style/1000-MB GBs)
            dateUsageSummary = strings.formatString(strings.data_usage_0_gb_of_1_gb_used_so_far, usedGBOneDecimalPlace, availableGBOneDecimalPlace);
        }

        var totalTopupsUsedMessage = null;
        if (dataUsageDetails.topups && dataUsageDetails.topups.length > 0) {
            totalTopupsUsedMessage = strings.formatString(strings.data_usage_includes_0_top_ups, dataUsageDetails.topups.length);
        }

        try {
            if (subscription.planCode !== "nsp") {

                var limitReachedMessage = subscription.streamingRemaining <= 0 ? <span className="red"><i className="material-icons yellow">warning</i>{strings.formatString(strings.data_limit_reached)}</span> : null;
                return (
                    <div className='row modal-main-content data-usage'>
                        <div className="col-12 data-usage">
                            <div>
                                <h3><i className="material-icons">data_usage</i>{strings.formatString(strings.data_usage_title)}</h3>
                                <p>{dateUsageSummary} {totalTopupsUsedMessage} {limitReachedMessage}</p>
                                <DataWidget
                                    dataUsageGrandTotalBytes={dataUsageGrandTotalBytes}
                                    dataUsageGrandTotalAvailable={dataUsageGrandTotalAvailable}
                                    planTotalSizeBytes={planTotalSizeBytes}
                                    topUps={topUps}
                                />
                                <p>{!subscription.noLimitPlan ? strings.formatString(strings.data_top_up_warning) : null}</p>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } catch (e) {
            console.error(e);
            return null
        }
    }
    
    renderSubscriptionTab(subscription) {
        if(this.state.showServicePlan){
            if(BuildSettings.billingEnabled && subscription && subscription.planCode !== "nsp"){
                return this.renderSubscriptionDetails(subscription);
            }
            else{
                return this.renderNoSubSection(subscription);
            }
        }
        else{
            return this.renderFleetServicePlan();
        }
    }

    renderSubscriptionDetails(subscription) {

        const buttonDisabled = window.recurly ? false : true;


        if (subscription && subscription.planCode !== "nsp") {
            var priceString = subscription.amountInCents.toString();
            var planPrice = parseFloat(subscription.amountInCents) === 0 ? 'FREE' : priceString.slice(0, priceString.length - 2) + '.' + priceString.slice(priceString.length - 2, priceString.length);
            var planTitle = subscription.planCode;
            if (strings["plan_title_" + subscription.planCode]) planTitle = strings.formatString(strings["plan_title_" + subscription.planCode]);

            var addOns = null;
            try {
                if (subscription.addOns) addOns = subscription.addOns.map((addOn, i) => {
                    return (
                        <tr key={i}>
                            <td><label>{strings.raven_subscription_details_add_on_label} - {addOn.type}</label></td>
                            <td><p>{addOn.price === 'FREE' ? addOn.price : '$' + addOn.price + " USD"}</p></td>
                        </tr>
                    )
                })
            } catch (e) {
                console.warn("failed to render add ons", e);
            }

            var pendingSubscription = undefined;
            if (this.props.accountDetails) {
                pendingSubscription = this.props.accountDetails.subscriptions.find(sub => {
                    return sub.state === 'pending' && sub.subscriptionUuid === subscription.subscriptionUuid;
                });
            }
            var pendingSubSection = null;
            if (pendingSubscription) {
                var pendingSubTitle = pendingSubscription.planCode;
                if (strings["plan_title_" + pendingSubscription.planCode]) pendingSubTitle = strings.formatString(strings["plan_title_" + pendingSubscription.planCode]);
                // var pendingPriceString = pendingSubscription.amountInCents.toString();
                // var pendingPlanPrice = parseFloat(pendingSubscription.amountInCents) === 0 ? 'FREE' : pendingPriceString.slice(0, pendingPriceString.length - 2) + '.' + pendingPriceString.slice(pendingPriceString.length - 2, pendingPriceString.length);
                // pendingSubSection = (
                //     <div>
                //         <h5>Next Plan</h5>
                //         <table className="pricing-table">
                //             <tbody>
                //                 <tr>
                //                     <td><label>Next Plan - {pendingSubTitle}</label></td>
                //                     <td><p>{pendingPlanPrice === 'FREE' ? pendingPlanPrice : '$' + pendingPlanPrice + " USD"}</p></td>
                //                 </tr>
                //             </tbody>
                //         </table>
                //         <p>Your plan will change at the beginning of the next billing cycle ({moment(subscription.currentBillingPeriod.end).format('LL')})</p>
                //     </div>
                // )
                pendingSubSection = <p>{strings.raven_subscription_your_plan_will_change_to} <span className="blue">{pendingSubTitle}</span>.</p>
            }

            return (
                <div className='row'>
                    <div className="col-12 modal-main-content plan-details">
                        <h3><i className="material-icons">assignment</i>{strings.raven_current_billing_period_title}</h3>
                        <p className="gray">{moment(subscription.currentBillingPeriod.start).format('LL')} - {moment(subscription.currentBillingPeriod.end).format('LL')}</p>
                        <p>{strings.raven_subscription_your_current_service_plan_is} <span className="blue">{planTitle}</span>.</p>
                        {!pendingSubscription ?
                            <p>{strings.raven_subscription_your_plan_will_auto_renew_at_the_end_of_the_current_billing_cycle}</p>
                            : <p>{strings.raven_subscription_your_plan_will_change_to} <span className="blue">{pendingSubTitle}</span></p>
                        }
                        {subscription.state === 'canceled' ?
                            <p><i className="material-icons yellow">warning</i><span className="yellow text-bold">{strings.raven_subscription_plan_canceled}</span> {strings.raven_subscription_plan_canceled_description}</p>
                            : null}
                    </div>

                    <div className="col-12 actions">
                        { 
                            // first see if we should display the button at all
                            // then see if it is disabled due to no recurly JS or not
                            (subscription.pendingSub || subscription.planSelectionRequired || !subscription.noLimitPlan) ? (buttonDisabled ?
                            <button className="btn" onClick={this.openEditPlanModal} disabled title="Enable Javascript to edit service plan"><i className="material-icons">edit</i>{strings.raven_subscription_edit_plan_action}</button> :
                            <button className="btn" onClick={this.openEditPlanModal}><i className="material-icons">edit</i>{strings.raven_subscription_edit_plan_action}</button>) : null
                        }

                        <button className="btn btn-outline-blue" onClick={this.closeRavenModal}><i className="material-icons">clear</i>{strings.app_close}</button>

                        <EditPlanModal {...this.props} {...this.state}
                            closeEditPlanModal={this.closeEditPlanModal}
                            raven={this.state.currentRaven}
                            subscription={subscription}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderNoSubSection(subscription) {

        var buttonDisabled = window.recurly ? false : true;

        return (
            <div className='row'>
                <div className="col-12 modal-main-content no-service-plan">
                    <p><i className="material-icons yellow">warning</i>{strings.formatString(strings.no_plan_message)}</p>
                </div>
                <div className="col-12 actions">
                    {this.props.accountDetails ? (
                        buttonDisabled ?
                            <button className="btn" onClick={this.openEditPlanModal} disabled title="Enable Javascript to start a service plan"><i className="material-icons">edit</i>{strings.raven_subscription_start_a_service_plan}</button> :
                            <button className="btn" onClick={this.openEditPlanModal}><i className="material-icons">edit</i>{strings.raven_subscription_start_a_service_plan}</button>) : null}
                            <button className="btn btn-outline-blue" onClick={this.closeRavenModal}><i className="material-icons">clear</i>{strings.app_close}</button>
                    <EditPlanModal {...this.props} {...this.state}
                        closeEditPlanModal={this.closeEditPlanModal}
                        subscription={subscription}
                        raven={this.state.currentRaven}
                    />
                </div>
            </div>
        )
    }

    renderFleetServicePlan() {
        return (
            <div className='row'>
                <div className="col-12 modal-main-content fleet-plan">
                    <p>{strings.raven_subscription_to_change_plan_please_contact_label} <a href={"mailto:" + globals.salesEmail}>{globals.salesEmail}</a></p>
                </div>
                <div className="col-12 actions">
                    <button className="btn btn-outline-blue" onClick={this.closeRavenModal}><i className="material-icons">clear</i>{strings.app_close}</button>
                </div>
            </div>
        );
    }

    render() {
        const isContentReady = this.isContentReady();

        return (
            <div id="ravensPage" className='container account-page'>
                <div className='row'>
                    <div className='col-10'>
                        <h1>{strings.ravens_page_title}</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {this.state.successMessage && !this.state.isRavenModalOpen && <div className='success-message'>{this.state.successMessage}</div>}
                        {this.state.errorMessage && !this.state.isRavenModalOpen && <div className='error-message'>{this.state.errorMessage}</div>}
                    </div>
                </div>
                {isContentReady ?
                    <>
                        <div className='row'>
                            {this.renderStats()}
                        </div>
                        <div className='row'>
                            <div className='col-8 instructions'>
                                <span>{strings.formatString(strings.tags_click_to_manage_x_tags, strings.raven_name, <i className="material-icons tag-edit-icon">edit</i>)}</span>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>

                                <RavensTable
                                    ravens={this.state.filteredRavens}
                                    tags={this.state.tags}
                                    filters={this.state.filters}
                                    setListFilter={this.setListFilters}
                                    openRavenDataUsageModal={this.openRavenDataUsageModal}
                                    openRavenPlanModal={this.openRavenPlanModal}
                                    openRavenTagsModal={this.openRavenTagsModal}
                                    shouldRenderRavenDataUsage={this.shouldRenderRavenDataUsage}
                                    shouldRenderRavenSubscription={this.shouldRenderRavenSubscription}
                                    getRavenDataUsageDetails={this.getRavenDataUsageDetails}
                                    showServicePlan={this.state.showServicePlan}
                                />

                                {this.state.isRavenModalOpen && this.renderRavenModal()}
                            </div>
                        </div>
                    </>
                    :
                    <div className='row'>
                        <div className='col-12'>
                            {this.renderContentLoadingStatus()}
                        </div>
                    </div>
                }            
            </div>
        );
    }
}

class RavensTable extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            columns: this.getColumns(),
        }
    }

    newColumn = (header, accessor, overrides = {} ) => {
        return {
            Header: strings[`ravens_page_list_header_${header}`],
            accessor: accessor,
            Placeholder: strings.formatString(strings.reports_header_filter_x_names, strings.raven_name),
            filterable: false,
            className: 'react-table-column',
            headerClassName: 'react-table-column',
            ...overrides
        }
    }

    renderDataUsageCell(raven, subscription) {

        if(!this.props.shouldRenderRavenDataUsage(subscription)) return null;

        const details = this.props.getRavenDataUsageDetails(subscription);

        if(!details) return null;

        const {usedPercentage, availableGBOneDecimalPlace} = details;

        let tooltip = strings.formatString(strings.data_usage_0_percentage_of_1_gb_used_so_far, usedPercentage, availableGBOneDecimalPlace);
        
        return <div className='raven-data-usage-cell' style={{'--data-used': `${usedPercentage}%`}}>
                <div onClick={() => this.props.openRavenDataUsageModal(raven)} title={tooltip} className='circle'></div>
            </div>
    }

    renderSubscriptionCell(raven, subscription) {

        if(!this.props.shouldRenderRavenSubscription()) return null;

        let content = '';

        switch(true){
            case !BuildSettings.billingEnabled:
            case !subscription:
                content = <i title={strings.no_plan_message} className="material-icons no-service-plan">warning</i>;;
                break;
            case subscription.planSelectionRequired:
                content = <i title={strings.formatString(strings.raven_free_trial_message, moment(subscription.currentBillingPeriod.end).fromNow())} className="material-icons trial-ending">error_outline</i>;
                break;
            case subscription.state === 'canceled':
                content = <i title={strings.raven_subscription_your_plan_is_canceled} className="material-icons canceled">warning</i>;
                break;
            case subscription.planCode === 'nsp':
                content = <i title={strings.raven_subscription_youve_selected_no_Service_plan} className="material-icons no-service-plan">warning</i>;
                break;
            default:
                content = subscription.planCode;
        }
        
        return <div onClick={() => this.props.openRavenPlanModal(raven)} className='plan-glimps' >{content}</div>
    }

    getColumns = () => {
        const {tags, openRavenTagsModal} = this.props;

        const consumerColumns = [];

        if(this.props.showServicePlan){
            consumerColumns.push(this.newColumn('data', 'subscription', {
                Cell: row => this.renderDataUsageCell(row.original, row.value),
                width: 100
            }));

            consumerColumns.push(this.newColumn('plan', 'subscription', {
                Cell: row => this.renderSubscriptionCell(row.original, row.value),
                width: 80
            }));
        }

        const columns = [
            this.newColumn('name', 'vehicle.name',
            {
                filterable: true,
                width: 200,
            }),
            this.newColumn('tags', 'tags',
            {
                filterable: true,
                className: 'react-table-grow-column',
                headerClassName: 'react-table-grow-column',
                Filter: ({filter, onChange}) => {
                    return <div className='list-filter-by-tags-select'>
                        <TagsTreeViewDropDown
                                tags={tags}
                                placeholder={strings.tags_filter_by_tags}
                                selectedTagsIds={filter ? filter.value : []}
                                onChange={(selectedTagsIds) => onChange(selectedTagsIds)}
                                className='react-table-header-filter'
                                showConfrimOnDeselect={false}
                                multipleSelection
                                compact
                            />
                        </div>
                },
                Cell: row => {
                    return <TagsList linear={true} tags={row.value} showMore={true} onMore={() => openRavenTagsModal(row.original)} />
                }
            }),
            ...consumerColumns,
            this.newColumn('', undefined, {
                Cell: row => <div className="more"><button onClick={() => openRavenTagsModal(row.original)} className='btn btn-more btn-outline-transparent'><i className="material-icons">edit</i></button></div>,
                width: 50
            })
        ];

        return columns;
    }

    render() {
        const {ravens, filters, setListFilter} = this.props;

        return <ReactTable
                filterable={true}
                sortable={false}
                showPagination = {false}
                minRows = {0}
                pageSize = {ravens.length}
                data={ravens}
                noDataText={strings.no_match_for_selected_filters}
                filtered={filters}
                defaultFilterMethod={(filter, row) => {
                    return true;
                }}
                columns={this.state.columns}
                getTrProps={(state, rowInfo, column) => {
                    return { className: '-rollup'};
                }}
                onFilteredChange={(filtered, column, value) => {
                    setListFilter(column.id, value);                    
                }}
            />
    }
}

const mapStateToProps = state => {
    return {
        tagRavensChangesPending: Selectors.tagPropChangePending(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        deleteTagRaven: (tagId, raven) => dispatch(DispatchHelpers.deleteTagRaven(tagId, raven)),
        addTagRaven: (tagId, raven) => dispatch(DispatchHelpers.addTagRaven(tagId, raven)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RavensPage);